import {
    type AnalyticsMembershipEvent,
    type AnalyticsUserEvent,
} from '@fruitful/types';

import { hasActiveStytchSession } from '../../auth/stytchHelpers';
import { fetcher } from '../../http/Fetcher';

export const logToBackend = async (
    event: AnalyticsUserEvent | AnalyticsMembershipEvent,
    data?: Record<string, string | number | boolean>,
    level?: 'membership',
) => {
    if (level !== 'membership') {
        throw new Error('Not implemented');
    }

    /* Endpoint is authed, verify we have a valid session before posting.  */
    if (!hasActiveStytchSession()) {
        return;
    }

    return await fetcher({
        method: 'POST',
        endpoint: '/api/user/membership-events/track',
        body: JSON.stringify({
            eventType: event,
            metadata: data,
        }),
    });
};

export const logFruitSliceEventToBackend = async (
    eventType: string,
    metadata?: Record<string, string | number | boolean>,
) => {
    /* Endpoint is authed, verify we have a valid session before posting.  */
    if (!hasActiveStytchSession()) {
        return;
    }

    return await fetcher({
        method: 'POST',
        endpoint: '/api/user/track-fruit-slice-event',
        body: JSON.stringify({
            eventType,
            metadata,
        }),
    });
};
